import { render, staticRenderFns } from "./customWriteoff.vue?vue&type=template&id=51b770e0&scoped=true&"
import script from "./customWriteoff.vue?vue&type=script&lang=js&"
export * from "./customWriteoff.vue?vue&type=script&lang=js&"
import style0 from "./customWriteoff.vue?vue&type=style&index=0&id=51b770e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b770e0",
  null
  
)

export default component.exports